module.exports = __webpack_public_path__ + "img/iPhone 16 Pro.71cae9dc.jpg";